'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const react = require('@emotion/react');
const components_navigation_InteractiveTag_InteractiveTagIcon = require('./InteractiveTagIcon.cjs.js');
const components_navigation_InteractiveTag_InteractiveTagWrapper = require('./InteractiveTagWrapper.cjs.js');

const InteractiveTag = ({ children, color = "primary", href, iconAfter, iconAfterAriaHidden = true, iconAfterAriaLabel, iconBefore, iconBeforeAriaHidden = true, iconBeforeAriaLabel, onClick, maxWidth = "none" }) => {
  return react.jsx(
    components_navigation_InteractiveTag_InteractiveTagWrapper.InteractiveTagWrapper,
    { color, href, onClick, maxWidth },
    iconBefore && react.jsx(components_navigation_InteractiveTag_InteractiveTagIcon.InteractiveTagIcon, { "aria-hidden": iconBeforeAriaHidden, "aria-label": iconBeforeAriaLabel, name: iconBefore, position: "before" }),
    children,
    iconAfter && react.jsx(components_navigation_InteractiveTag_InteractiveTagIcon.InteractiveTagIcon, { "aria-hidden": iconAfterAriaHidden, "aria-label": iconAfterAriaLabel, name: iconAfter, position: "after" })
  );
};

exports.InteractiveTag = InteractiveTag;
//# sourceMappingURL=InteractiveTag.cjs.js.map
